import DaumPostcodeEmbed, { Address } from 'react-daum-postcode';
import { useState } from 'react';
import CSS from "./static/css/postcode.module.css";
import Input from '../Input/Input';
import SearchIcon from '../Icon/SearchIcon/SearchIcon';
import Overlay from '../Overlay/Overlay';
import useHistoryBackContralOverlayState from '../Overlay/hooks/useHistoryBackContralOverlayState.hook';

const Postcode = (
    {
        zonecode,
        mainAddress,
        addressDetail,
        addressDetailChangeHandler,
        setRowAddressData,
        onCompositionStart,
        onCompositionEnd,
        readOnly,
    }:{
        zonecode: string;
        mainAddress: string;
        addressDetail: string;
        addressDetailChangeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
        setRowAddressData?: React.Dispatch<React.SetStateAction<Address | null>>;
        onCompositionStart?: () => void;
        onCompositionEnd?: () => void;
        readOnly?: boolean;
    }
) => {
    const {
        isOpen,
        openOverlay,
        closeOverlay
    } = useHistoryBackContralOverlayState(false);

    const handleOpenModal = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation();

        if(readOnly){
            return ;
        }

        openOverlay();
    }

    // const handleCloseModal = () => {
    //     closeOverlay();
    // }

    const handleComplete = (data: Address) => {
        if(setRowAddressData){
            setRowAddressData(data);
        }

        closeOverlay();
    }

    return (
        <div className={CSS.l_Postcode_main}>
            <div className={CSS.l_Postcode_inputContainer}>
                <div
                    className={`${CSS.l_Postcode_inputEleContainer} ${CSS.PostNumer}`}
                    onClick={handleOpenModal}
                >
                    <Input
                        value={zonecode}
                        readOnly={true}
                        placeholder="우편번호 검색"
                    >
                        <SearchIcon />
                    </Input>
                </div>

                <div
                    className={`${CSS.l_Postcode_inputEleContainer} ${CSS.Address}`}
                    onClick={handleOpenModal}
                >
                    <Input
                        value={mainAddress}
                        readOnly={true}
                        placeholder="주소 입력"
                    />
                </div>

                <div className={`${CSS.l_Postcode_inputEleContainer} ${CSS.DetailAddress}`}>
                    <Input
                        value={addressDetail}
                        onChange={addressDetailChangeHandler}
                        placeholder="상세 주소 입력"
                        readOnly={readOnly}
                        onCompositionStart={onCompositionStart}
                        onCompositionEnd={onCompositionEnd}
                    />
                </div>
            </div>

            <Overlay
                isOverlayOpen={isOpen}
                overlayCloseHandler={closeOverlay}
            >
                {
                    // DaumPostcodeEmbed컴포넌트는 onComplete가 동작한 직후 컴포넌트 자체가 소멸해 버리는것 같다
                    // 그래서 다시 사용하기위해 화면에 다시 띄우려고해도 단순 상태변환만으로는 화면에 다시는 나오지 못한다.
                    // 다시 보이게 하기위해 랜더링 자체를 다시 할 필요가 있다.
                    // 아직 다른 해결방안은 찾지 못함
                    isOpen
                    &&  <div className={CSS.l_Postcode_DaumPostcodeEmbedOverlay}>
                            <DaumPostcodeEmbed
                                // 2026-02-26 -김효민- 카카오 지도 api 변경 예고에 따라 라이브러리 업데이트 전까지 미리 변경 처리(라이브러리 업데이트 완료로 인해 사용하지 않는 코드)
                                // scriptUrl="https://t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"
                                onComplete={handleComplete}
                            />
                        </div>
                }
            </Overlay>
        </div>
    )
}

export default Postcode;